import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-10" }
const _hoisted_3 = { class: "col-12 col-md-2 d-flex align-items-center" }
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "НДС", -1)
const _hoisted_6 = { class: "nav nav-tabs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border text-center fw-bold" }, "Материал"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border text-center fw-bold" }, "Общее кол-во"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border text-center fw-bold" }, "Кол-во для закупа"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border text-center fw-bold" }, "Цена"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border text-center fw-bold" }, "Сумма")
], -1)
const _hoisted_10 = { class: "col-3 border d-flex align-items-center" }
const _hoisted_11 = { class: "col-2 border d-flex align-items-center justify-content-end" }
const _hoisted_12 = { class: "col-2 border" }
const _hoisted_13 = { class: "col-2 border" }
const _hoisted_14 = { class: "col-3 border d-flex align-items-center justify-content-end" }
const _hoisted_15 = { class: "col-12 row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 border d-flex align-items-center" }, "Доставка", -1)
const _hoisted_17 = { class: "col-2 border" }
const _hoisted_18 = { class: "col-2 border" }
const _hoisted_19 = { class: "col-3 border d-flex align-items-center justify-content-end" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "fw-bold text-end py-1" }
const _hoisted_22 = { class: "col-12 mt-2" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-4 border text-center fw-bold" }
const _hoisted_25 = { class: "col-4 border text-center fw-bold" }
const _hoisted_26 = { class: "col-4 border text-center fw-bold" }
const _hoisted_27 = {
  key: 1,
  class: "row mb-4"
}
const _hoisted_28 = { class: "col-12 mt-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h6", null, "Условия оплаты", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border text-center fw-bold" }, "Транш"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-5 border text-center fw-bold" }, "Процент"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-5 border text-center fw-bold" }, "Сумма")
], -1)
const _hoisted_31 = { class: "col-2 border" }
const _hoisted_32 = { class: "col-5 border" }
const _hoisted_33 = { class: "col-5 border d-flex align-items-center justify-content-end" }
const _hoisted_34 = { class: "col-12 mt-2" }
const _hoisted_35 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from 'vue';
import { useModal } from '@/composables/useModal';
import api from '@/api';
import { ISupplier } from '@/@types/ISupplier';
import formatMoney from '@/utils/formatMoney';
import { CURRENCY } from '@depo/constants/purchase';

type protocolSupplierMaterialType = {
    sum: string;
    total: number;
    quantity: string;
    unitPrice: string;
    groupId: number;
    protocolMaterialId: number;
    material: {
        materialName: string;
        count: string;
        unit: string;
        requiredMaterialIds: Array<{ count: string; id: number }>;
    };
};

type stateType = {
    id: number;
    supplierId: number | string;
    isVatIncludedInPrice: boolean;
    description?: string;
    shippingQuantity: string;
    shippingPrice: string;
    selectedTab: string;
    currency: string;
    exchangeRate: string;
    materialsWithPrice: protocolSupplierMaterialType[];
    paymentTranches: {
        number: number;
        percent: number;
    }[];
    visibleErrors: boolean;
    loader: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplierSelectionModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const TAB = {
    PURCHASE: 'Закуп',
    PAYMENT: 'Оплата',
};

const props = __props;

const modal = useModal(props.id);

const suppliers = ref<ISupplier[]>([]);

const state: stateType = reactive({
    id: 0,
    supplierId: '',
    isVatIncludedInPrice: false,
    description: '',
    materialsWithPrice: [],
    currency: CURRENCY.KZ_TENGE,
    exchangeRate: '1',
    selectedTab: TAB.PURCHASE,
    shippingQuantity: '',
    shippingPrice: '',
    paymentTranches: [
        {
            percent: 0,
            number: 0,
        },
        {
            percent: 0,
            number: 1,
        },
        {
            percent: 0,
            number: 2,
        },
    ],
    visibleErrors: false,
    loader: false,
});

const CURRENCY_COLLECTION = Object.values(CURRENCY).map((currency) => ({ id: currency, name: currency }));
const TAB_COLLECTION = Object.values(TAB);

const isSupplierIdError = computed(() => !state.supplierId);
const isUnitPriceError = computed(() => (material: any) => {
    return (+material.quantity ? +material.unitPrice <= 0 : +material.unitPrice < 0) || !isFinite(+material.unitPrice);
});
const isQuantityError = computed(() => (material: protocolSupplierMaterialType) => {
    if (material.material.requiredMaterialIds.length !== 1) {
        return +material.quantity !== +material.material.count;
    }

    return +material.quantity < 0 || +material.quantity > +material.material.count;
});

const materialsTotal = computed(() =>
    state.materialsWithPrice.reduce((acc, mp) => {
        if (isUnitPriceError.value(mp) || !+mp.quantity) {
            return acc;
        }

        return acc + +mp.quantity * +mp.unitPrice;
    }, 0),
);

const total = computed(() => materialsTotal.value + shippingTotal.value);

const isExchangeRateError = computed(() => +state.exchangeRate <= 0);

const isShippingPriceError = computed(() => {
    return +state.shippingPrice < 0 || (!materialsTotal.value && !!shippingTotal.value);
});
const isShippingQuantityError = computed(() => +state.shippingQuantity < 0);

const isTranchesError = computed(() => state.paymentTranches.reduce((acc, t) => acc + +t.percent, 0) !== 100);
const shippingTotal = computed(() => +state.shippingQuantity * +state.shippingPrice);

const computeMaterialTotal = computed(() => (material: any) => {
    return !isUnitPriceError.value(material) && material.quantity ? +material.quantity * +material.unitPrice : 0;
});

const computedTranchTotal = computed(
    () => (percent: number) => (total.value && percent ? total.value * (percent / 100) : 0),
);

onMounted(() => {
    if (Object.values(modal.data?.protocolSupplier || {}).length) {
        state.supplierId = modal.data.protocolSupplier.supplierId;
        state.description = modal.data.protocolSupplier.description || '';
        state.isVatIncludedInPrice = modal.data.protocolSupplier.isVatIncludedInPrice;
        state.materialsWithPrice = modal.data.protocolSupplier.materialsWithConditions.map((m: any) => ({
            ...m,
        }));
        state.shippingPrice = modal.data.protocolSupplier?.shippingPrice || 0;
        state.shippingQuantity = modal.data.protocolSupplier?.shippingQuantity || 0;
        state.exchangeRate = modal.data.protocolSupplier?.exchangeRate || '1';
        state.currency = modal.data.protocolSupplier?.currency || CURRENCY.KZ_TENGE;
        state.paymentTranches = modal.data.protocolSupplier?.paymentTranches.length
            ? modal.data.protocolSupplier?.paymentTranches.map((pt: any) => ({
                number: pt.number,
                percent: pt.tranchPercent,
            }))
            : [0, 1, 2].map((number) => ({ number, percent: 0 }));
    }
    if (modal.data?.suppliers?.length) {
        suppliers.value = modal.data?.suppliers;
    }
});

function handleChangeNextBtn() {
    const isErrorsExist = state.materialsWithPrice.some((rm) => isUnitPriceError.value(rm) || isQuantityError.value(rm)) ||
        isSupplierIdError.value ||
        isShippingPriceError.value ||
        isShippingQuantityError.value ||
        isExchangeRateError.value;

    if (isErrorsExist) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.selectedTab = TAB.PAYMENT;
}

function handleSupplierSelect(m: any) {
    state.supplierId = m.id;
}

function handleCurrencySelect(m: { id: string }) {
    state.currency = m.id;
    if (m.id === CURRENCY.KZ_TENGE) {
        state.exchangeRate = '1';
    }
}

function handleUnitPriceChange(idx: number) {
    state.materialsWithPrice[idx].unitPrice = state.materialsWithPrice[idx].unitPrice.replaceAll(',', '.');
}

function handleShippingQuantityChange() {
    state.shippingQuantity = state.shippingQuantity.replaceAll(',', '.');
}

function handleShippingPriceChange() {
    state.shippingPrice = state.shippingPrice.replaceAll(',', '.');
}

function handleExchangeRateChange() {
    state.exchangeRate = state.exchangeRate.replaceAll(',', '.');
}

const isErrorsExist = computed(() => {
    return (
        state.materialsWithPrice.some((rm) => isUnitPriceError.value(rm) || isQuantityError.value(rm)) ||
        isSupplierIdError.value ||
        isTranchesError.value ||
        isShippingPriceError.value ||
        isShippingQuantityError.value ||
        isExchangeRateError.value
    );
});

function send() {
    if (isErrorsExist.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;

    api.supplierSelection
        .updateSupplier({
            protocolSupplierId: modal.data.protocolSupplier.id,
            supplierId: state.supplierId,
            isVatIncludedInPrice: state.isVatIncludedInPrice,
            description: state.description,
            materialsWithPrice: state.materialsWithPrice,
            paymentTranches: state.paymentTranches,
            shippingQuantity: state.shippingQuantity,
            shippingPrice: state.shippingPrice,
            exchangeRate: state.exchangeRate,
            currency: state.currency,
        })
        .then((r) => {
            modal.ok(r.data);
        });
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_text_area_ui = _resolveComponent("text-area-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-lg",
    title: "Редактировать выбор поставщика"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите поставщика",
              label: "Поставщик",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isSupplierIdError.value,
                  "item-key": "name",
                  options: suppliers.value,
                  searchable: true,
                  values: [state.supplierId],
                  onOnUpdated: handleSupplierSelect
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.isVatIncludedInPrice) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, state.isVatIncludedInPrice]
              ]),
              _hoisted_5
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAB_COLLECTION), (tab) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tab,
              class: "nav-item",
              onClick: ($event: any) => (state.selectedTab = tab)
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link text-black", { active: state.selectedTab === tab }]),
                href: "#"
              }, _toDisplayString(tab), 3)
            ], 8, _hoisted_7))
          }), 128))
        ]),
        (state.selectedTab === TAB.PURCHASE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.materialsWithPrice, (materialWithPrice, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: materialWithPrice.protocolMaterialId,
                  class: "col-12 row"
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(materialWithPrice.material?.materialName), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(materialWithPrice?.material.count) + "  " + _toDisplayString(materialWithPrice?.material?.unit), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_form_group_ui, {
                      "invalid-feedback": "Укажите количество",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_input_ui, {
                          modelValue: materialWithPrice.quantity,
                          "onUpdate:modelValue": ($event: any) => ((materialWithPrice.quantity) = $event),
                          class: "mt-2 text-end",
                          "is-invalid": state.visibleErrors && isQuantityError.value(materialWithPrice),
                          mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                          maxlength: "12",
                          placeholder: "Количество",
                          onInput: ($event: any) => (handleUnitPriceChange(idx))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid", "onInput"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_form_group_ui, {
                      "invalid-feedback": "Укажите цену",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_input_ui, {
                          modelValue: materialWithPrice.unitPrice,
                          "onUpdate:modelValue": ($event: any) => ((materialWithPrice.unitPrice) = $event),
                          class: "mt-2 text-end",
                          "is-invalid": state.visibleErrors && isUnitPriceError.value(materialWithPrice),
                          mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                          maxlength: "12",
                          placeholder: "Цена",
                          onInput: ($event: any) => (handleUnitPriceChange(idx))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid", "onInput"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("b", null, _toDisplayString(_unref(formatMoney)(computeMaterialTotal.value(materialWithPrice))), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_form_group_ui, {
                    "invalid-feedback": "Укажите количество",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_input_ui, {
                        modelValue: state.shippingQuantity,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.shippingQuantity) = $event)),
                        class: "mt-2 text-end",
                        "is-invalid": state.visibleErrors && isShippingQuantityError.value,
                        mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                        maxlength: "12",
                        placeholder: "Количество",
                        onInput: handleShippingQuantityChange
                      }, null, 8, ["modelValue", "is-invalid"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_form_group_ui, {
                    "invalid-feedback": "Ошибочная цена",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_input_ui, {
                        modelValue: state.shippingPrice,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.shippingPrice) = $event)),
                        class: "mt-2 text-end",
                        "is-invalid": state.visibleErrors && isShippingPriceError.value,
                        mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                        maxlength: "12",
                        placeholder: "Цена",
                        onInput: handleShippingPriceChange
                      }, null, 8, ["modelValue", "is-invalid"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("b", null, _toDisplayString(_unref(formatMoney)(shippingTotal.value)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, " Итого: " + _toDisplayString(_unref(formatMoney)(total.value)) + " " + _toDisplayString(state.currency) + " (без НДС: " + _toDisplayString(_unref(formatMoney)(!state.isVatIncludedInPrice ? total.value : total.value / 1.12)) + " " + _toDisplayString(state.currency) + ") ", 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_form_group_ui, {
                      label: "Валюта",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_select_ui, {
                          "item-key": "name",
                          options: _unref(CURRENCY_COLLECTION),
                          values: [state.currency],
                          onOnUpdated: handleCurrencySelect
                        }, null, 8, ["options", "values"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_form_group_ui, {
                      "invalid-feedback": "Ошибочный курс",
                      label: "Курс",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_input_ui, {
                          modelValue: state.exchangeRate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.exchangeRate) = $event)),
                          class: "mt-2 text-end",
                          disabled: state.currency === _unref(CURRENCY).KZ_TENGE,
                          "is-invalid": state.visibleErrors && isExchangeRateError.value,
                          mask: { mask: 'Z*', tokens: { Z: { pattern: /^[0-9.,]+$/ } } },
                          maxlength: "12",
                          placeholder: "Курс",
                          onInput: handleExchangeRateChange
                        }, null, 8, ["modelValue", "disabled", "is-invalid"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, " Cумма в нац. валюте: " + _toDisplayString(_unref(formatMoney)(total.value * Number(state.exchangeRate))) + "  (без НДС: " + _toDisplayString(_unref(formatMoney)(
                                    !state.isVatIncludedInPrice
                                        ? total.value * Number(state.exchangeRate)
                                        : (total.value / 1.12) * Number(state.exchangeRate),
                                )) + ") ", 1)
                ])
              ]),
              _createElementVNode("div", { class: "col-12 text-center mt-2" }, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: handleChangeNextBtn
                }, " Далее ")
              ])
            ]))
          : _createCommentVNode("", true),
        (state.selectedTab === TAB.PAYMENT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.paymentTranches, (tranch) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tranch.number,
                    class: "row"
                  }, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(tranch.number + 1), 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_form_group_ui, {
                        "invalid-feedback": "Сумма процентов траншей должно быть 100",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_input_ui, {
                            modelValue: tranch.percent,
                            "onUpdate:modelValue": ($event: any) => ((tranch.percent) = $event),
                            class: "mt-2 text-end",
                            "is-invalid": state.visibleErrors && isTranchesError.value,
                            placeholder: "Инфо",
                            type: "number"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(formatMoney)(computedTranchTotal.value(+tranch.percent))), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Условия поставки",
                  label: "Условия поставки"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_area_ui, {
                      modelValue: state.description,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.description) = $event)),
                      placeholder: "Условия поставки"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Сохранить ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})